import { Box, Grid, Typography } from "@mui/material";
import { useContext, useState } from "react";
import useAssignUserManagement from "../../../../../../api/hooks/useAssignUserManagement";
import { useCheckUserPermission } from "../../../../../../api/hooks/useCheckUserPermission";
import AssigneeSelector from "../../../../../../components/assignee/AssigneeSelector";
import { CustomerFeatureFlagsContext } from "../../../../../../contexts/CustomerFeatureFlagsContext";
import { PLATFORM_USER_ACTIONS } from "../../../../../../utils/constants";
import AsanaInteractionManager from "../../../../../stack/integrations/Asana/AsanaInteractionManager";
import JiraInteractionManager from "../../../../../stack/integrations/Jira/JiraInteractionManager";
import ScanMenuButton from "../../ScanMenuButton";
import AutoRemediationButton from "./autoRemediation/AutoRemediationButton";
import PlaybookButton from "./PlaybookButton";
import RemediationDetailsSection from "./RemediationDetailsSection";
import CopyLinkButton from "../CopyLinkButton";

const HeaderRemediationSection = ({
  selectedRemediation,
  demoMode,
  fullControl,
}) => {
  const [isScanLoading, setIsScanLoading] = useState(false);
  const {
    usersMap,
    handleAssignControlAndRemediation,
    isControlRemediationLoading,
  } = useAssignUserManagement();
  const { autoRemediationActive } = useContext(CustomerFeatureFlagsContext);

  const handleAssigneeChange = (assignee) => {
    handleAssignControlAndRemediation(
      selectedRemediation?.remediation_id,
      assignee
    );
  };
  const { permitted: hasPermission } = useCheckUserPermission(
    PLATFORM_USER_ACTIONS.ASSIGN_REMEDIATION_TO_USER
  );
  const remediationId = selectedRemediation?.remediation_id;
  const selectedAssignee =
    usersMap.get(selectedRemediation?.assignee_email) || null;

  return (
    <Grid container direction="row" spacing={2} pt={3}>
      <Grid item xs={12}>
        <Grid container direction="row">
          <Grid item xs={10}>
            <Typography variant="h5">{selectedRemediation?.name}</Typography>
          </Grid>
          <Grid item xs={2} display={"flex"} justifyContent={"flex-end"}>
            <Typography variant="h5">
              #{selectedRemediation?.remediation_id}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container direction="row" spacing={2} alignItems={"center"}>
          <Grid
            container
            direction="column"
            item
            xs={12}
            justifyContent="space-between"
            gap={2}
          >
            <RemediationDetailsSection
              selectedRemediation={selectedRemediation}
              demoMode={demoMode}
              fullControl={fullControl}
            />
            <Grid item xs={7} display={"flex"} direction={"column"} gap={1}>
              <Typography variant="subtitle2">Quick Actions</Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                <ScanMenuButton
                  isScanLoading={isScanLoading}
                  setLoading={setIsScanLoading}
                  loadingMessage={"Analyzing systems for this control..."}
                  gapIdsToScan={[fullControl?.control_id]}
                  gapIdsToSnooze={[]}
                  tooltipText={"Scan this control"}
                />
                <AssigneeSelector
                  value={selectedAssignee}
                  onChange={handleAssigneeChange}
                  size="medium"
                  hideLabel={true}
                  loading={isControlRemediationLoading(remediationId)}
                  hasPermission={hasPermission}
                />
                <JiraInteractionManager
                  fullControl={fullControl}
                  sx={{ height: "32px" }}
                  hideTitle={true}
                />
                <AsanaInteractionManager
                  fullControl={fullControl}
                  sx={{ height: "32px" }}
                  hideTitle={true}
                />
                <PlaybookButton
                  control={fullControl}
                  sx={{ height: "30px", padding: "0 6px" }}
                />
                {autoRemediationActive && (
                  <AutoRemediationButton
                    fullControl={fullControl}
                    remediation={selectedRemediation}
                  />
                )}
                <CopyLinkButton
                  controlId={fullControl?.control_id}
                  remediationId={selectedRemediation?.remediation_id}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default HeaderRemediationSection;
